export const PERMISSIONS: { [x: string]: any } = {
  EMPLOYEE_VIEW_PAGE: ["v_per_all_employee", "v_per_unit_employee"],
  EMPLOYEE_UPDATE_PAGE: [
    "f_per_all_employee",
    "f_per_unit_employee",
    // "can_edit_employee_details",
  ],
  EMPLOYEE_EDIT_PAGE: ["can_edit_employee_details"],
  EMPLOYEE_CREATE_PAGE: ["f_per_all_employee", "f_per_unit_employee"],

  EMPLOYEE_POSITION_LIST_PAGE: ["can_view_employee"],

  POSITION_VIEW_PAGE: ["v_per_all_positions"],
  POSITION_MODIFY_PAGE: ["f_per_all_positions"],

  ACR_LIST_PAGE: ["v_per_all_acr", "v_per_unit_acr"],
  ACR_UPDATE_PAGE: ["f_per_all_acr", "f_per_unit_acr"],

  CAN_VIEW_OWN_FILE_INQUIRY: ["can_view_own_enquiry_file"],
  CAN_VIEW_ALL_FILE_INQUIRY: ["can_view_enquiry_file"],
  CAN_EDIT_FILE_INQUIRY: ["can_edit_enquiry_file"],
  CAN_CREATE_FILE_INQUIRY: ["can_create_enquiry_file"],
  CAN_ASSIGN_FILE_INQUIRY: ["can_assign_enquiry_file"],

  LEAVE_VIEW_PAGE: ["v_per_all_leave", "v_per_unit_leave", "v_per_own_leave"],
  LEAVE_MODIFY_PAGE: ["f_per_all_leave", "f_per_unit_leave", "f_per_own_leave"],
  LEAVE_UPDATE: ["can_update_leave"],
  LEAVE_SETTINGS_UPDATE: ["can_update_leave_settings"],

  APR_LIST_PAGE: ["v_per_all_apr", "v_per_unit_apr"],
  APR_UPDATE: ["f_per_all_apr", "f_per_unit_apr"],

  DOSSIER_LIST_PAGE: ["v_per_all_dossier", "v_per_unit_dossier"],
  DOSSIER_UPDATE: ["f_per_all_dossier", "f_per_unit_dossier"],

  PUNISHMENT_LIST_PAGE: ["v_per_all_punishment", "v_per_unit_punishment"],
  PUNISHMENT_UPDATE: ["f_per_all_punishment", "f_per_unit_punishment"],

  ATTENDANCE_VIEW_PAGE: [
    "v_per_all_attendance",
    "v_per_unit_attendance",
    "v_per_own_attendance",
  ],
  ATTENDANCE_MODIFY_PAGE: [
    "f_per_all_attendance",
    "f_per_unit_attendance",
    "f_per_own_attendance",
  ],

  SENIORITY_LIST_PAGE: ["v_per_all_seniority"],

  CAN_EDIT_USER_CREDENTIAL: ["can_edit_user_credential"],

  PROMOTION_INITIATE: ["can_initiate_promotion"],
  PROMOTION_LIST_VIEW_PAGE: [
    "v_per_all_promotion",
    "v_per_unit_promotion",
    // "v_per_own_promotion",
  ],
  PROMOTION_MODIFY_PAGE: [
    "f_per_all_promotion",
    "f_per_unit_promotion",
    // "v_per_own_promotion",
  ],

  PERMANENT_LIST_PAGE: ["v_per_all_permanent"],

  ACCOUNT_STATUS_UPDATE: ["can_update_account_status"],
  RETIREMENT_INITIATE: ["can_initiate_retirement"],
  RETIREMENT_LIST_PAGE: [
    // "v_per_own_retirement",
    "v_per_unit_retirement",
    "v_per_all_retirement",
  ],

  RESIGNATION_INITIATE: ["can_initiate_resignation"],
  RESIGNATION_LIST_PAGE: [
    // "v_per_own_resignation",
    "v_per_unit_resignation",
    "v_per_all_resignation",
  ],

  RELEASE_UPDATE: ["f_per_all_release"],

  TRANSFER_INITIATE: ["can_initiate_transfer"],
  TRANSFER_LIST_PAGE: [
    "v_per_own_transfer",
    "v_per_unit_transfer",
    "v_per_all_transfer",
  ],
  TRANSFER_MODIFY_PAGE: ["f_per_all_transfer", "f_per_own_transfer"],

  DECEASED_INITIATE: ["can_initiate_deceased"],
  DECEASED_LIST_PAGE: ["v_per_all_deceased", "f_per_all_deceased"],

  TERMINATION_INITIATE: ["can_initiate_termination"],
  TERMINATION_LIST_PAGE: ["v_per_all_termination", "f_per_all_termination"],

  GPF_LIST_PAGE: ["v_per_own_gpf", "v_per_all_gpf", "v_per_unit_gpf"],

  ASSIGN_MAINTENANCE: ["can_assign_maintenance"],
  ROOM_BOOKING: ["can_approved_room_booking", "can_reject_room_booking"],
  REQUISITION_APPROVE: ["can_approve_requisition"],
  REQUISITION_ASSIGN: ["assign_per_all_requisition"],
  REQUISITION_VIEW_PAGE: ["v_per_all_requisition"],

  E_TICKET_VIEW_MY_TICKET: ["v_per_own_e_ticket"],
  E_TICKET_EDIT_MY_TICKET: ["f_per_own_e_ticket"],

  IT_HEAD: ["v_per_all_e_ticket", "f_per_all_e_ticket"],
  IT_EMPLOYEE: ["v_per_assigned_e_tickets"],

  TASK_HEAD: ["v_per_all_task", "f_per_all_task"],

  E_TICKET_ASSIGN: ["can_assign_e_ticket", "f_per_all_e_ticket"],

  E_TICKET_VIEW_PAGE: [
    "v_per_all_e_ticket",
    "v_per_unit_e_ticket",
    "v_per_own_e_ticket",
  ],
  E_TICKET_MODIFY_PAGE: [
    "f_per_all_e_ticket",
    "f_per_unit_e_ticket",
    "f_per_own_e_ticket",
  ],

  PROCUREMENT_INITIATE: ["can_initiate_procurement"],
  ASSIGN_COMMITTEE: ["can_assign_committee"],
  PROCUREMENT_MODIFY_PAGE: ["f_per_all_procurement"],
  PROCUREMENT_VIEW_PAGE: ["v_per_all_procurement"],
  PROCUREMENT_ASSIGN: ["v_per_assign_procurement"],
  STORE_IN_CHARGE: ["store_in_charge"],
  PROCUREMENT_HR: ["store_in_charge_admin"],
  PROCUREMENT_STORE_IN_CHARGE: ["store_in_charge_admin", "store_in_charge"],
  APPROVE_VENDOR: ["can_approve_vendor"],

  INVENTORY_SETTINGS_PAGE: ["f_per_all_settings"],
  INVENTORY_BUDGET_PAGE: ["f_per_all_budget_inventory"],
  INVENTORY_STOCK_PAGE: ["f_per_all_stock"],
  INVENTORY_PROCUREMENT_PAGE: ["f_per_all_procurement_inventory"],
  // INVENTORY_MAINTENANCE_PAGE: ["f_per_all_maintenance"],
  INVENTORY_MAINTENANCE_PAGE: [],
  // INVENTORY_MAINTENANCE_CREATE_PAGE: [
  //   "f_per_all_maintenance",
  //   "f_per_own_maintenance",
  // ],
  INVENTORY_MAINTENANCE_CREATE_PAGE: [],
  INVENTORY_WARRANTY_PAGE: ["v_per_all_warrenty"],
  INVENTORY_EMPLOYEE_PAGE: ["v_per_all_inventory_employee"],
  INVENTORY_FORECASTING_PAGE: ["v_per_all_forecasting"],
  INVENTORY_ROOM_PAGE: ["f_per_all_settings_room"],
  INVENTORY_APPROVE_REQUISITION: ["can_approve_requisition"],
  INVENTORY_ASSIGN_REQUISITION: ["assign_per_all_requisition"],

  INVENTORY_APPROVE_REQUISITION_S: "can_approve_requisition",
  INVENTORY_ASSIGN_REQUISITION_S: "assign_per_all_requisition",
  CAN_ADD_EXTRA_RESPONSIBILITY: ["can_add_extra_responsibility"],
  CAN_VIEW_ORG_CHART: ["can_view_org_chart"],
  CAN_HRM_SETTINGS: ["can_hrm_settings"],
  CAN_VIEW_EMPLOYEE_STAT: ["can_view_employee_stat"],

  //task management

  TASK_VIEW_OWN_TASK: ["v_per_own_task"],
  TASK_EDIT_OWN_TASK: ["f_per_own_task"],

  // report
  CAN_DOWNLOAD_ALL_REPORTS: ["d_all_report"],
};
